import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, palette, TableLoader, BasicTooltip, ExpandedTooltip, getUtility } from '@livable/saas-react-components';
import { Box, Button, TextField, Typography } from '@mui/material';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import { useDelay } from 'src/utils/hooks';
// import { PropertyMenu } from './PropertyMenu';
import useStyles from './styles';
import { PropertyCheckElement } from './propertyCheckElement';
import RippleEffect from 'src/components/general/RippleEffect';
import { currencyFormatter } from 'src/utils/translator';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { useNavigate } from 'react-router-dom';
import { ActiveBuildingMenu } from 'src/components/property/ActiveBuildingMenu';
import { InactiveBuildingMenu } from 'src/components/property/InactiveBuildingMenu';
import { useStore } from 'src/stores';
import moment from 'moment/moment';
export const PropertiesDataGrid = observer(_ref => {
  let searchKey = _ref.searchKey,
    selectedRows = _ref.selectedRows,
    propertiesList = _ref.propertiesList,
    isLoadingExt = _ref.isLoadingExt,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    setShowEnrollModalSelectedPropertyId = _ref.setShowEnrollModalSelectedPropertyId,
    triggerRefresh = _ref.triggerRefresh,
    isSelectAllPropertiesEnabled = _ref.isSelectAllPropertiesEnabled,
    handleShowManageAccessModal = _ref.handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal = _ref.handleShowAutoBillingBatchModalModal;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  const store = useStore();
  const _useState = useState({
      pageSize: 25,
      page: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    paginationModel = _useState2[0],
    setPaginationModel = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    sortModel = _useState4[0],
    setSortModel = _useState4[1];
  const handleSetSortModel = async data => {
    if (!data.length) {
      data = [{
        field: 'Unitname',
        sort: 'asc'
      }];
    }
    setSortModel(data);
  };
  const handleSetPaginationModel = async data => {
    setPaginationModel(data);
  };
  useDelay(() => {}, [searchKey], 1000);
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const Cell = _ref2 => {
    let field = _ref2.field,
      icon = _ref2.icon,
      row = _ref2.row,
      cellType = _ref2.cellType,
      rowIndex = _ref2.rowIndex;
    const getFieldWrapper = type => {
      if (type === 'propertyAddress') {
        return /*#__PURE__*/React.createElement(ExpandedTooltip, {
          title: row.propertyAddress,
          placement: "top"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }
        }, field));
      } else if (type === 'property-status') {
        return row.propertyStatus === 'Active' ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
          title: "Launched on ".concat(moment(row.enrollmentDate).format('MM/DD/YYYY')),
          type: row.propertyStatus === 'Active' ? 'success' : 'info',
          placement: "top"
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: row.propertyStatus === 'Active' ? 'success' : 'info'
        }, row.propertyStatus)) : /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: row.propertyStatus === 'Active' ? 'success' : 'info'
        }, row.propertyStatus);
      } else if (cellType === 'utilities') {
        var _row$utilities;
        return !!((_row$utilities = row.utilities) !== null && _row$utilities !== void 0 && _row$utilities.length) ?
        /*#__PURE__*/
        // return (
        React.createElement(ExpandedTooltip, {
          type: "utilities-success",
          title: /*#__PURE__*/React.createElement("div", {
            className: classes.utilitiesTooltip
          }, /*#__PURE__*/React.createElement("div", {
            className: "tooltip-header"
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "h6"
          }, t('portfolios_properties_page.property_utilities'))), /*#__PURE__*/React.createElement("div", {
            className: "tooltip-content"
          }, row.utilities.map(util => /*#__PURE__*/React.createElement("div", {
            key: uuid(),
            className: classes.utilitiesTooltipItem
          }, getUtility(util).icon(), /*#__PURE__*/React.createElement(Typography, {
            variant: "h5"
          }, util))))),
          placement: "top"
        }, field) :
        // );
        field;
      } else if (cellType === 'autoBillingStatus') {
        return /*#__PURE__*/React.createElement(Typography, {
          className: classes.autoBillingStatus,
          variant: "formHint",
          state: rowIndex % 2 === 0 ? 'success' : rowIndex % 3 === 0 ? 'inactive' : 'error',
          onClick: event => {
            event.stopPropagation();
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            rowIndex % 2 !== 0 && handleShowAutoBillingBatchModalModal(true, row, 'test portfolio data');
          }
        }, rowIndex % 2 !== 0 ? /*#__PURE__*/React.createElement(Icon, {
          fontSize: "small",
          state: "warning",
          type: "paper-dollar"
        }) : rowIndex % 3 === 0 ? /*#__PURE__*/React.createElement(Icon, {
          fontSize: "small",
          state: "lightGrey",
          type: "paper-dollar"
        }) : /*#__PURE__*/React.createElement(Icon, {
          fontSize: "small",
          state: "error",
          type: "paper-dollar"
        }));
      } else {
        return field;
      }
    };
    return /*#__PURE__*/React.createElement(RippleEffect, {
      className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
    }, icon ? /*#__PURE__*/React.createElement(Icon, {
      state: icon === 'building' ? 'success' : 'info',
      type: icon === 'building' ? 'building' : 'edit'
    }) : null, getFieldWrapper(cellType));
  };
  const AccessCell = _ref3 => {
    let params = _ref3.params;
    const handleOpenTeamMangeModal = event => {
      event.stopPropagation();
      handleShowManageAccessModal(true, params.row, null);
    };
    const accessMembers = [...new Map([...params.row.accessResponses, ...params.row.portfolio.accessResponses].map(i => [i.accountId, i])).values()];
    if ((accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) > 0 && (accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) <= 3) {
      return /*#__PURE__*/React.createElement(RippleEffect, {
        className: 'cellContent'
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.avatarsBlock,
        onClick: handleOpenTeamMangeModal
      }, accessMembers.map(item => {
        return /*#__PURE__*/React.createElement("div", {
          className: classes.avatar
        }, /*#__PURE__*/React.createElement(BasicTooltip, {
          title: "".concat(item.firstName, " ").concat(item.lastName),
          placement: "top"
        }, item.firstName.toUpperCase().charAt(0)));
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.avatar, " ").concat(classes.avatarAddPlusBlock)
      }, "+")));
    } else if ((accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) > 0 && (accessMembers === null || accessMembers === void 0 ? void 0 : accessMembers.length) > 3) {
      const avatars = accessMembers;
      const spliceRes = avatars.splice(0, 3);
      return /*#__PURE__*/React.createElement(RippleEffect, {
        className: 'cellContent'
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.avatarsBlock,
        onClick: handleOpenTeamMangeModal
      }, spliceRes.map(item => {
        return /*#__PURE__*/React.createElement("div", {
          className: classes.avatar
        }, ' ', /*#__PURE__*/React.createElement(BasicTooltip, {
          title: "".concat(item.firstName, " ").concat(item.lastName),
          placement: "top"
        }, item.firstName.toUpperCase().charAt(0)));
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.avatar, " ").concat(classes.avatarAddPlusBlock)
      }, "+", avatars.length)));
    } else {
      return /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "small",
        onClick: handleOpenTeamMangeModal,
        'custom-attribute': '758-properties-data-grid'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "user-add"
      }));
    }
  };
  const goToTenancies = id => {
    navigate("/residencies?id=".concat(id, "&tab=residencies"));
  };
  const handleCellClick = params => {
    if (['autoBillingStatus', 'actions', 'select', 'access'].includes(params.field)) return;
    if (params.row.propertyStatus === PROPERTY_STATUS_ENUM.Inactive) {
      navigate("/new_property?not_completed_id=".concat(params.row.propertyId));
    } else {
      goToTenancies(params.row.propertyId);
    }
  };
  const columns = [{
    field: 'select',
    align: 'center',
    width: 70,
    sortable: false,
    renderCell: params => {
      var _params$row;
      return /*#__PURE__*/React.createElement(PropertyCheckElement, {
        data: params.row,
        propertyId: params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.propertyId,
        onSelect: item => {
          var _params$row2;
          return store.portfoliosMultiActionStore.isSelected(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.propertyId) ? store.portfoliosMultiActionStore.deselectSelectedItem(item.propertyId) : store.portfoliosMultiActionStore.setSelectedItem(item);
        },
        isHeader: false
      });
    },
    renderHeader: () => /*#__PURE__*/React.createElement(PropertyCheckElement, {
      data: columns,
      propertyId: 'select-all',
      onSelect: () => propertiesList.reduce((acc, item) => {
        if (acc) {
          if (store.portfoliosMultiActionStore.isSelected(item.propertyId)) {
            return acc;
          } else return false;
        } else return false;
      }, true) ? store.portfoliosMultiActionStore.deselectAll(propertiesList) : store.portfoliosMultiActionStore.selectAll(propertiesList),
      isHeader: true,
      isHeaderChecked: propertiesList.reduce((acc, item) => {
        if (acc) {
          if (store.portfoliosMultiActionStore.isSelected(item.propertyId)) {
            return acc;
          } else return false;
        } else return false;
      }, true)
    })
  }, {
    minWidth: 250,
    maxWidth: 600,
    align: 'left',
    field: 'propertyAddress',
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      cellType: 'propertyAddress',
      field: params.row.propertyAddress,
      icon: params.row.propertyStatus === 'Active' ? 'building' : 'edit',
      row: params.row
    }),
    renderHeader: () => renderHeader('Property'),
    flex: 1
  }, {
    field: 'propertyStatus',
    width: 100,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: params.row.propertyStatus,
      row: params.row,
      cellType: 'property-status'
    }),
    renderHeader: () => renderHeader('Status')
  }, {
    field: 'unitsTotal',
    width: 75,
    headerAlign: 'left',
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: "".concat(params.row.unitsEnrolled, "/").concat(params.row.unitsTotal),
      row: params.row
    }),
    renderHeader: () => renderHeader('Total units', true)
  }, {
    field: 'utilities',
    width: 75,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: params.row.utilityCount,
      cellType: 'utilities',
      row: params.row
    }),
    renderHeader: () => renderHeader('Utilities', true)
  }, {
    align: 'right',
    field: 'accountsReceivable',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.accountsReceivable ? currencyFormatter(Number(params.row.accountsReceivable)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader('Account Receivable', true),
    width: 115
  }, {
    align: 'right',
    field: 'payoutToDate',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.distributionToDate ? currencyFormatter(Number(params.row.distributionToDate)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: 'to date'
    }), true),
    width: 115
  }, {
    align: 'right',
    field: 'july',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.distributionForCurrentMonth ? currencyFormatter(Number(params.row.distributionForCurrentMonth)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: moment().format('MMMM YY')
    }), true),
    width: 115
  }, {
    align: 'right',
    field: 'august',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: !!params.row.distributionForNextMonth ? currencyFormatter(Number(params.row.distributionForNextMonth)) : 'N/A',
      row: params.row
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: moment().add(1, 'month').format('MMMM YY')
    }), true),
    width: 115
  }, {
    field: 'autoBillingStatus',
    headerAlign: 'left',
    sortable: false,
    renderCell: params => {
      var _params$row3;
      return /*#__PURE__*/React.createElement(Cell, {
        field: !((_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.autoBillingStatus),
        row: params.row,
        cellType: 'autoBillingStatus',
        rowIndex: params.api.getAllRowIds().indexOf(params.id) + 1
      });
    },
    renderHeader: () => renderHeader('Auto-billing', true),
    width: 105
  }, {
    align: 'right',
    field: 'access',
    headerAlign: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(AccessCell, {
      params: params
    }),
    renderHeader: () => renderHeader('Access', true),
    width: 115
  }, {
    field: 'actions',
    width: 130,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    filterable: false,
    hideable: false,
    renderCell: params => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, params.row.propertyStatus !== PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActiveBuildingMenu, {
      id: params.row.propertyId,
      menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
        type: "dotdotdot"
      }),
      handleShowEnrollModal: handleShowEnrollModal,
      setShowEnrollModalSelectedPropertyId: setShowEnrollModalSelectedPropertyId,
      handleShowManageAccessModal: () => handleShowManageAccessModal(true, params.row, null)
    })), params.row.propertyStatus === PROPERTY_STATUS_ENUM.Inactive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: t('dashboard_page.continue_adding_details'),
      placement: "top",
      hideOnMobile: true
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      onClick: () => navigate("/new_property?not_completed_id=".concat(params.row.propertyId)),
      'custom-attribute': '759-properties-data-grid'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }))), /*#__PURE__*/React.createElement(InactiveBuildingMenu, {
      id: params.row.propertyId,
      menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
        type: "dotdotdot"
      }),
      deletePropertyCallBackAction: () => {
        triggerRefresh();
      }
    })))),
    renderHeader: () => /*#__PURE__*/React.createElement("div", {
      className: classes.toolboxWrapperHeader
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      type: "button",
      'custom-attribute': '760-properties-data-grid'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    })))
  }];

  // Note: needed portfolio name on all properties view
  if (isSelectAllPropertiesEnabled) {
    columns.splice(2, 0, {
      minWidth: 150,
      maxWidth: 300,
      align: 'left',
      field: 'portfolioName',
      renderCell: params => /*#__PURE__*/React.createElement(Cell, {
        field: params.row.portfolio.name,
        row: params.row
      }),
      renderHeader: () => renderHeader('Portfolio name'),
      flex: 1
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.tableContainer, " ").concat(!!store.portfoliosMultiActionStore.selectedItems.length ? classes.multiselectEnabled : '')
  }, isLoadingExt ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(Box, {
    sx: {
      [".".concat(gridClasses.cell, ".active")]: {
        color: palette.success.main
      },
      [".".concat(gridClasses.cell, ".inactive")]: {
        color: palette.info.main
      }
    }
  }, /*#__PURE__*/React.createElement(DataGrid, {
    autoHeight: true,
    getRowId: () => uuid(),
    columns: columns,
    onCellClick: handleCellClick,
    getCellClassName: params => {
      if (params.field === 'status') return params.row.status === 'Active' ? 'active' : 'inactive';
    },
    initialState: {
      sorting: {
        sortModel: [
        // NOTE: disabling undesired sorting fields
        {
          field: 'enrolled',
          sortable: false
        }]
      }
    },
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: properties => /*#__PURE__*/React.createElement(Button, _extends({}, properties, {
        variant: "actionButton",
        'custom-attribute': '761-properties-data-grid'
      })),
      BaseTextField: properties => /*#__PURE__*/React.createElement(TextField, _extends({}, properties, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    disableRowSelectionOnClick: true,
    hideFooterSelectedRowCount: true,
    columnHeaderHeight: 78,
    rowHeight: 78,
    rows: propertiesList,
    rowSelectionModel: selectedRows,
    onSortModelChange: model => handleSetSortModel(model),
    onPaginationModelChange: model => handleSetPaginationModel(model),
    paginationModel: paginationModel,
    sortModel: sortModel,
    className: classes.grid
  })));
});